<template>
  <a-modal :title="title" :width="900" :visible="visible" @cancel="handleCancel">
    <template #footer>
      <a-button @click="handleCancel">取消</a-button>
      <a-button v-show="title == '添加药房' " :loading="confirmLoading" type="primary" @click="handleSubmit">确定</a-button>
      <a-button v-show="title == '编辑详情' " :loading="EditLoading" type="primary" @click="handleEdit">编辑</a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="药房名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-row style="height:30px">
            <a-col :span="12">
              <a-input placeholder="请输入药房名称" v-model="form.pharmacyName" />
            </a-col>
            <a-col :span="12"></a-col>
          </a-row>

        </a-form-item>
        <a-form-item label="药房类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-row style="height:30px">
            <a-col :span="12">
              <a-select placeholder="请选择药方类型" v-model="form.tyep" :options="roomType"></a-select>
            </a-col>
            <a-col :span="12"></a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="是否支持物流配送" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch checked-children="是" un-checked-children="否" v-model="isDelivery" />
        </a-form-item>
        <a-form-item label="是否推荐" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch checked-children="是" un-checked-children="否" v-model="isRecom" />
        </a-form-item>
        <a-form-item label="联系电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <!--  v-decorator="['phone', {rules: [{required: true, message: '请输入电话！'}]}]" -->
          <a-input v-model="form.phone" placeholder="请输入联系电话" />
          <!-- <a-input placeholder="请输入电话"  /> -->
        </a-form-item>

        <!-- <a-form-item label="所属地区" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-row style="height:30px">
            <a-col :span="6">
              <a-select v-model="form.regionProvinceCode" placeholder="请选择城市" @change="handleAreaChange"
                :options="areaList">
              </a-select>
            </a-col>
            <a-col :span="6">
              <a-select v-model="form.regionCityCode" @change="regionCityCode" style="margin-left:5px"
                :options="cityList" placeholder="请选择市区">
              </a-select>
            </a-col>
          </a-row>
        </a-form-item> -->

        <a-form-item label="所属地区" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-row style="height:30px">
            <a-col :span="6">
              <a-select v-model="form.provinceCode" placeholder="请选择城市" @change="handleArea2Change" :options="areaList">
              </a-select>
            </a-col>
            <a-col :span="6">
              <a-select v-model="form.cityCode" style="margin-left:5px" :options="cityList" placeholder="请选择市区">
              </a-select>
            </a-col>
            <a-col :span="12">
              <a-input placeholder="请输入详细地址" v-model="form.addressDetail" style="margin-left:10px" />
            </a-col>
          </a-row>

        </a-form-item>
        <a-form-item label="药房小图" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <img v-if="type == 1" style="width:200px;height:200px" :src="form.orgLogoUrl" alt="">
          <a-upload v-else name="avatar" list-type="picture-card" class="avatar-uploader" :show-upload-list="false"
            :customRequest="fileUpdate" :before-upload="beforeUpload">
            <img v-if="imageUrl" style="width:162px;height:162px" :src="imageUrl" alt="">
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                Upload
              </div>
            </div>
          </a-upload>
        </a-form-item>

        <a-form-item label="药房介绍" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea placeholder="请输入药房介绍" :auto-size="{ minRows: 4, maxRows: 6 }" v-model="form.pharmacyDesc" />
          <!-- <a-input placeholder="请输入是否启用" v-decorator="['useflag', {rules: [{required: true, message: '请输入是否启用！'}]}]" /> -->
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { baPharmacyAdd, baPharmacyArea, baPharmacyEdit } from '@/api/modular/interhospital/bapharmacy/baPharmacyManage';
 
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        visible: false,
        confirmLoading: false,
        EditLoading : false,

        queryParam : [],
        roomType : [
          { label: '内配', value: 1 },
          { label: '外配', value: 2 },
        ],
      
        // 上传小图
        form: {},
        imageUrl: '',
        loading: false,
        type: 1,

        // 是否推荐 是否配送
        isDelivery: false,
        isRecom: false,

        areaList: [],
        cityList: [],
        

        title : '查看详情',
      }
    },
    methods: {
      // 初始化方法
      add(record, isHow, title) {

        console.log(record)
        this.title = title;
        this.visible = true;
        
        if (isHow) {
          this.type = 2
        } else {
          this.type = 1
        }
        this.isHow = isHow;

        
        if (title == '添加药房') {
          this.form = {}
          // 获取地区
          this.getArea();
        } else {
          this.form = Object.assign({}, record);
          this.imageUrl = this.form.url;
          // 获取地区
          this.getArea();
          this.getArea(this.form.provinceId);
        }
        
        this.isDelivery = this.form.isDelivery == 0 ? false : true;
        this.isRecom = this.form.isRecom == 0 ? false : true;
        console.log(this.form)
        
      },

      // 获取地区
      getArea(parentId) {
        let params = {}
        if (parentId) {
          params = {
            parentId,
          }
        }
        baPharmacyArea(params).then(res => {
          // console.log(res)
          if (res.code == 200) {
            if (!parentId) {
              this.areaList = [];
              res.data.map(item => {
                this.areaList.push({
                  label: item.areaName,
                  value: +item.areaCode,
                  provinceId: item.areaId
                })
              })
            } else {
              this.cityList = [];
              res.data.map(item => {
                this.cityList.push({
                  label: item.areaName,
                  value: +item.areaCode,
                  provinceId: item.areaId
                })
              })
            }
            
          } else {
            this.$message.error('获取行政区划失败')
          }
        })
      },  
      
      // 所属地区
      handleArea2Change(value, node) {
        this.getArea(node.data.props.provinceId);
      },

      /**
       * 提交表单
       */
      handleSubmit () {
        this.confirmLoading = true
        let params = {
          "pharmacyName": this.form.pharmacyName,
          "pharmacyCode": this.form.pharmacyCode, //药房编码
          "tyep": this.form.tyep, //类型 1-内配 2-外配
          "isDelivery": this.isDelivery?1:0, //是否支持配送 0否1是
          "isRecom": this.isRecom?1:0, //是否推荐 0否1是
          "phone": this.form.phone, //联系方式
          // "regionProvinceCode": this.form.regionProvinceCode, //所属省编码
          // "regionCityCode": this.form.regionCityCode, //所属市编码
          "provinceCode": this.form.provinceCode, //省编码
          "cityCode": this.form.cityCode, //市编码
          "areaCode": this.form.areaCode, //区编码
          "addressDetail": this.form.addressDetail, //详细地址
          "pharmacyDesc": this.form.pharmacyDesc //药房描述
        }
        baPharmacyAdd(params).then((res) => {
          this.confirmLoading = false;
          if (res.code == 200) {
            this.$message.success('新增成功')
            this.$emit('ok')
            this.handleCancel()
          } else {
            this.$message.error('新增失败')// + res.message
          }
        })
      },
      handleCancel () {
        this.visible = false
      },
      // 编辑
      handleEdit() {
        this.EditLoading = true;
        let params = {
          "pharmacyId": this.form.pharmacyId,
          "pharmacyName": this.form.pharmacyName,
          "pharmacyCode": this.form.pharmacyCode, //药房编码
          "tyep": this.form.tyep, //类型 1-内配 2-外配
          "isDelivery": this.isDelivery ? 1 : 0, //是否支持配送 0否1是
          "isRecom": this.isRecom ? 1 : 0, //是否推荐 0否1是
          "phone": this.form.phone, //联系方式
          // "regionProvinceCode": this.form.regionProvinceCode, //所属省编码
          // "regionCityCode": this.form.regionCityCode, //所属市编码
          "provinceCode": this.form.provinceCode, //省编码
          "cityCode": this.form.cityCode, //市编码
          "areaCode": this.form.areaCode, //区编码
          "addressDetail": this.form.addressDetail, //详细地址
          "pharmacyDesc": this.form.pharmacyDesc //药房描述
        }
        baPharmacyEdit(params).then((res) => {
          this.EditLoading = false;
          if (res.code == 200) {
            this.$message.success('编辑成功')
            this.$emit('ok')
            this.handleCancel()
          } else {
            this.$message.error('编辑失败')// + res.message
          }
        })
      },
      // 自定义文件上传
      beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('建议上传图片大小不超过2MB!');
        }
        return isLt2M;
      },
      fileUpdate(file) {
        const form = new FormData();
        form.append('file', file.file);
        pictureUpdate(form).then(res => {
          if (res.code == 200) {
            this.form.orgLogoUrl = res.data;
            this.imageUrl = res.data;
          } else {
            this.$message.error('上传图片失败')
          }
        })
      }
    }
  }
</script>
